<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_reports'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between">
              <div class="col-md-2">
                <label>Filter By Year</label>
                <v-select
                  v-model="year"
                  @input="fetchData()"
                  :options="years"
                ></v-select>
              </div>
              <div class="">
                <small class="me-1"><b>Export to </b></small>
                <b-button
                  :disabled="expenditures.length <= 0"
                  type="button"
                  class="btn btn-sm btn-success"
                  @click="printPDF"
                  >PDF <i class="mdi mdi-file-pdf"></i
                ></b-button>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="p-2" id="print-section">
              <h5 class="text-center">INCOME & EXPENDITURE {{ year }}</h5>
              <br />
              <div class="row">
                <div class="col-md-6">
                  <h4><i class="fas fa-redo"></i> Income</h4>
                  <table class="table table-sm">
                    <tr class="text-uppercase">
                      <th>Item</th>
                      <th>Amount</th>
                    </tr>
                    <tr v-for="x in incomes" :key="x.id">
                      <td>{{ x.fee }}</td>
                      <td>{{ commas(x.payments) }}</td>
                    </tr>
                    <tr v-for="x in optionalincomes" :key="x.id">
                      <td>{{ x.fee }}</td>
                      <td>{{ commas(x.payments) }}</td>
                    </tr>
                    <tr v-for="x in accounts" :key="x.id">
                      <td>{{ x.account_name }}</td>
                      <td>{{ commas(x.balance) }}</td>
                    </tr>
                  </table>

                  <h5>
                    Total:
                    {{
                      commas(
                        Number(totalincomes) +
                          Number(totaloptionalincomes) +
                          Number(totalaccounts),
                      )
                    }}
                  </h5>
                </div>
                <div class="col-md-6" style="border-left: 1px solid gray;">
                  <h4><i class="fas fa-undo"></i> Expenditure</h4>
                  <table class="table table-sm">
                    <tr class="text-uppercase">
                      <th>Item</th>
                      <th>Amount</th>
                    </tr>
                    <tr v-for="x in expenditures" :key="x.id">
                      <td>{{ x.expense }}</td>
                      <td>{{ commas(x.expenseamount) }}</td>
                    </tr>
                    <tr v-for="x in liabilities" :key="x.id">
                      <td>{{ x.account_name }}</td>
                      <td>{{ commas(x.balance) }}</td>
                    </tr>
                  </table>

                  <h5>
                    Total:
                    {{
                      commas(Number(totalexpenses) + Number(totalliabilities))
                    }}
                  </h5>
                </div>
              </div>
              <h5 class="mt-3">
                <b
                  >SURPLUS/DEFICIT:
                  <span class="h1">{{
                    commas(
                      Number(totalincomes) +
                        Number(totaloptionalincomes) +
                        Number(totalaccounts) -
                        (Number(totalexpenses) + Number(totalliabilities)),
                    )
                  }}</span></b
                >
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
//   import Multiselect from "vue-multiselect";
import html2pdf from "html2pdf.js";

export default {
  page: {
    title: "Income & Expenditure",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Income & Expenditure",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Income & Expenditure", active: true },
      ],
      incomes: [],
      optionalincomes: [],
      expenditures: [],
      accounts: [],
      liabilities: [],
      year: new Date().getFullYear(),
    };
  },
  computed: {
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
    totalincomes() {
      var total = 0;
      this.incomes.forEach((item) => {
        var item_total = item.payments;
        total = Number(total) + Number(item_total);
      });
      return total;
    },
    totaloptionalincomes() {
      var total = 0;
      this.optionalincomes.forEach((item) => {
        var item_total = item.payments;
        total = Number(total) + Number(item_total);
      });
      return total;
    },
    totalaccounts() {
      var total = 0;
      this.accounts.forEach((item) => {
        var item_total = item.balance;
        total = Number(total) + Number(item_total);
      });
      return total;
    },
    totalliabilities() {
      var total = 0;
      this.liabilities.forEach((item) => {
        var item_total = item.balance;
        total = Number(total) + Number(item_total);
      });
      return total;
    },
    totalexpenses() {
      var total = 0;
      this.expenditures.forEach((item) => {
        var item_total = item.expenseamount;
        total = Number(total) + Number(item_total);
      });
      return total;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    printPDF() {
      const element = document.getElementById("print-section");
      const options = {
        filename: this.title + ".pdf",
        image: { type: "png", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      };
      html2pdf()
        .from(element)
        .set(options)
        .save();
    },
    async fetchData() {
      let formData = new FormData();
      formData.append("year", this.year);
      let url = "/fetchincomeandexpenditure";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.incomes = response.data.feespayments;
          this.optionalincomes = response.data.optionalfeespayments;
          this.expenditures = response.data.expenses;
          this.accounts = response.data.assets;
          this.liabilities = response.data.liabilities;
        }
      });
    },
  },
};
</script>
